























import Vue from 'vue'
import { mapGetters } from 'vuex'
import Search from '@/components/Search/Search.vue'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import { UserScope } from '@/models/users'

interface Data {
  searchValue: string
}

interface Methods {
  handleSearch: (text: string) => void
}

interface Computed {
  canDoScope: (scope: UserScope) => boolean
  canScriptEdit: boolean
}

interface Props {
  search: string
  isTemplatePage: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Search,
    PaidLabel,
  },
  props: {
    search: {
      default: () => '',
    },
    isTemplatePage: {
      default: () => false,
    },
  },
  data() {
    return {
      searchValue: '',
    }
  },
  methods: {
    handleSearch(text: string) {
      this.searchValue = text
      this.$emit('search', this.searchValue)
    },
  },
  computed: {
    ...mapGetters(['canDoScope']),
    canScriptEdit(): boolean {
      return !this.isTemplatePage && this.canDoScope(UserScope.ScriptsEdit)
    },
  },
  watch: {
    search(value) {
      this.searchValue = value
    },
  },
})
